export default __webpack_public_path__ + "static/media/ep.045ea219.jpeg";